/* apex-search.js — shared search intelligence.

   Lifted verbatim from sections/hero.liquid, where it worked but was stranded:
   only the hero search benefited. Both the hero and the header field now call
   the same implementation.

   agsExpand  — Shopify's tokeniser does not split "ISO27001" into "ISO 27001",
                so a visitor typing the standard without a space matched nothing.
                Spacing letter/digit runs before querying fixes it.
   agsRank    — re-ranks what Shopify returns so the toolkit carrying the SAME
                standard number wins: exact number match +100, a different number
                -50, the number appearing early in the title scores higher, and
                multi-standard combination kits sit below the single-standard one.
*/
window.ApexSearch = (function () {
  function normKey(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function nums(s) { return (s || '').match(/\d{3,6}/g) || []; }

  function expand(term) {
    return term.replace(/([A-Za-z])(\d)/g, '$1 $2').replace(/(\d)([A-Za-z])/g, '$1 $2');
  }

  function rank(products, term) {
    var qn = normKey(term), qnums = nums(term);
    return products.map(function (p, i) {
      var t = p.title || '', tn = normKey(t), tnums = nums(t), s = -i * 0.1;
      if (qnums.length) {
        var all = qnums.every(function (n) { return tnums.indexOf(n) !== -1; });
        s += all ? 100 : -50;
        var pos = t.indexOf(qnums[0]);
        if (pos >= 0) s += Math.max(0, 20 - pos / 4);          // named early = more focused
        var uniq = tnums.filter(function (n, k) { return tnums.indexOf(n) === k; });
        var extra = uniq.length - qnums.length;
        if (extra > 0) s -= Math.min(extra, 4) * 8;            // multi-standard combos rank lower
      }
      if (qn && tn.indexOf(qn) !== -1) s += 40;
      return { p: p, s: s };
    }).sort(function (a, b) { return b.s - a.s; }).map(function (x) { return x.p; });
  }

  /* Query Shopify's own predictive-search endpoint, expanded and re-ranked.
     Returns a promise for an array of products. */
  function lookup(term, url, limit, signal) {
    return fetch(url + '.json?q=' + encodeURIComponent(expand(term)) +
                 '&resources[type]=product&resources[limit]=' + (limit || 10),
                 signal ? { signal: signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var p = (d.resources && d.resources.results && d.resources.results.products) || [];
        return rank(p, term);
      });
  }

  return { expand: expand, rank: rank, lookup: lookup };
})();
